import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a2d9a51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ds-page-header__left" }
const _hoisted_2 = {
  key: 0,
  class: "ds-page-header__title"
}
const _hoisted_3 = {
  key: 1,
  class: "ds-page-header__subtitle"
}
const _hoisted_4 = { class: "ds-page-header__right" }

import { computed } from 'vue';
import DSButton from './DSButton.vue';

interface Props {
  title?: string;
  subtitle?: string;
  backButton?: boolean;
  size?: 'sm' | 'md' | 'lg';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DSPageHeader',
  props: {
    title: { default: '' },
    subtitle: { default: '' },
    backButton: { type: Boolean, default: false },
    size: { default: 'md' }
  },
  setup(__props: any) {

const props = __props;



const classes = computed(() => ({
  'ds-page-header--sm': props.size === 'sm',
  'ds-page-header--lg': props.size === 'lg',
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ds-page-header", classes.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "left", {}, () => [
        (_ctx.backButton)
          ? (_openBlock(), _createBlock(DSButton, {
              key: 0,
              icon: "arrow_back",
              variant: "ghost",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          (_ctx.subtitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.subtitle), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "right")
    ])
  ], 2))
}
}

})